// extracted by mini-css-extract-plugin
module.exports = {"container":"_72051c13"};